import { render } from "./MenuCard.vue?vue&type=template&id=16da32cd&ts=true"
import script from "./MenuCard.vue?vue&type=script&lang=ts"
export * from "./MenuCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__